import "lc-micro-slider/lc-micro-slider.min";
import "lc-micro-slider/themes/default_theme.css";
import "./lc-micro-slider.css";

const defaultSliderConfiguration = {
  addit_classes : ['lcms_default_theme'],
  nav_dots : true,
  slideshow_cmd : false,
  nav_arrows : false,
  extra_cmd_code : '<div class="text-under-picture-title"></div>',
};

function createLCSlider(target, sliderConfiguration = null) {
  const list = target.querySelector("ul");
  if(!list || list.children.length === 0) {
    return;
  }
  new lc_micro_slider(target, sliderConfiguration ?? defaultSliderConfiguration);
  target.addEventListener('lcms_slide_shown', function(e) {
    const newIndex = e.detail.slide_index;
    const titleWrapper = target.parentNode.querySelector(".mobile-picture-slide-image-title-wrapper, .desktop-picture-slide-image-title-wrapper");
    if (!titleWrapper) {
      return;
    }
    const titles = titleWrapper.querySelectorAll(".mobile-pic-ds-slide-title, .desktop-pic-ds-slide-title");
    const titlesHtml = titles[newIndex] ? titles[newIndex].innerHTML : "";
    const textUnderPictureTitle = target.querySelector(".text-under-picture-title");
    if (!textUnderPictureTitle) {
      return;
    }
    textUnderPictureTitle.innerHTML = titlesHtml;
  });
}

function setUpLCSlider(scope) {
  Array.from(scope.querySelectorAll(".mobile-picture-slide")).forEach(target => createLCSlider(target));
  Array.from(scope.querySelectorAll(".desktop-picture-slide")).forEach(target => {
    createLCSlider(target, {...defaultSliderConfiguration, nav_arrows: true});
  });
}

export {setUpLCSlider, createLCSlider, defaultSliderConfiguration};
